import React from 'react';
import PropTypes from 'prop-types';
import OtpInput from 'react-otp-input';
import { ThreeDots } from 'svg-loaders-react';
import Submit from '../../../components/common/Button';
import back from '../../../assets/images/left-arrow.svg';
import info from '../../../assets/images/tooltip-icon.svg';
import generateBankImageUrl from './generateBankImageUrl';
import formatToCurrency from '../../../utils/formatToCurrency';

import styles from './FundsTransferSummary.module.scss';

export const FundsTransferSummary = (props) => {
    const {
        FundsTransferFormState: state,
        setLoading,
        loading,
        dispatch,
        hasSetPin,
        setComponentToRender,
        handleOnSubmit,
        transactionCost,
    } = props;

    const bankImageUrl = generateBankImageUrl(state.beneficiaryBankCode);

    const handleChange = (transaction_pin) => {
        dispatch({
            type: 'UPDATE_FORM_STATE',
            payload: { transaction_pin },
        });
    };

    const isSubmitDisabled = state.transaction_pin.length !== 4 || loading;

    return (
        <div className={styles.container}>
            <div
                className={styles.back}
                onClick={() => {
                    setComponentToRender('form');
                }}
            >
                <img className={styles.backIcon} src={back} alt='Back' />
                <span className={styles.backText}>Back</span>
            </div>
            
            <div className={styles.logoContainer}>
                <img className={styles.logo} src={bankImageUrl} alt='Bank logo' />
            </div>
            
            <div className={styles.heading}>
                <div className={styles.headingIconContainer}>
                    <img className={styles.headingIcon} src={info} alt='Info' />
                </div>
                <div className={styles.headingText}>
                    Verify the information and enter your transaction pin to proceed.
                </div>
            </div>
            
            <div className={styles.content}>
                <div className={styles.contentItem}>
                    <span className={styles.contentHeading}>Account Name:</span>
                    <span className={styles.contentDetails}>
                        {state.accountName}
                    </span>
                </div>
                
                <div className={styles.contentItem}>
                    <span className={styles.contentHeading}>Bank:</span>
                    <span className={styles.contentDetails}>
                        {state.beneficiaryBankName}
                    </span>
                </div>
                
                <div className={styles.contentItem}>
                    <span className={styles.contentHeading}>Account Number:</span>
                    <span className={styles.contentDetails}>
                        {state.accountNumber}
                    </span>
                </div>
                
                <div className={styles.contentItem}>
                    <span className={styles.contentHeading}>Amount:</span>
                    <span className={styles.contentDetails}>
                        &#8358;{formatToCurrency(state.amount)}
                    </span>
                </div>
                
                <div className={styles.contentItem}>
                    <span className={styles.contentHeading}>Transaction cost:</span>
                    <span className={styles.contentDetails}>
                        &#8358;{formatToCurrency(transactionCost)}
                    </span>
                </div>
                
                <div className={`${styles.contentItem} ${styles.total}`}>
                    <span className={`${styles.contentHeading} ${styles.totalHeading}`}>
                        Total:
                    </span>
                    <span className={`${styles.contentDetails} ${styles.totalDetails}`}>
                        &#8358;{formatToCurrency(state.total)}
                    </span>
                </div>
                
                <p className={styles.otpText}>
                    Enter your transaction pin to proceed
                </p>
                
                <div className={styles.formContainer}>
                    <div className={styles.inputGroup}>
                        <OtpInput
                            value={state.transaction_pin}
                            onChange={handleChange}
                            numInputs={4}
                            inputStyle={styles.input}
                            isInputSecure={true}
                            separator={
                                <span style={{
                                    display: 'inline-block',
                                    width: '2rem',
                                }} />
                            }
                        />
                    </div>
                </div>
            </div>
            
            <Submit 
                onClick={handleOnSubmit} 
                disabled={isSubmitDisabled}
            >
                {loading ? <ThreeDots fill='white' /> : 'Proceed'}
            </Submit>
        </div>
    );
};

FundsTransferSummary.propTypes = {
    FundsTransferFormState: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    handleOnSubmit: PropTypes.func.isRequired,
    transactionCost: PropTypes.number.isRequired,
    setComponentToRender: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    setLoading: PropTypes.func.isRequired,
    hasSetPin: PropTypes.bool.isRequired,
};

export default FundsTransferSummary;